// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2Yl9o","insightsList":"newBusinessInsightsMenu_insightsList__3Gvm1","active":"newBusinessInsightsMenu_active__1cfxE"};